import React, { useEffect, useState } from "react";
import api from "../lib/api";
import VideoCard from "../components/VideoCard";
import PageHeroBanner from "../components/PageHeroBanner";
import { ORIGINALS_HOTSPOTS } from "../components/heroBannerHotspots";

/**
 * /originals — Tap IN Originals catalogue.
 *
 * For now we surface anything tagged `original` or in the `films` category
 * with an `is_original` flag. Falls back to the whole films catalogue if
 * neither field is set so the page is never empty on a fresh install.
 */
export default function Originals() {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        // Prefer dedicated tag/flag if backend supports it, else fall back to films
        let r = await api.get("/videos?tag=original&limit=60").catch(() => null);
        if (!r || !(r.data || []).length) {
          r = await api.get("/videos?category=films&limit=60");
        }
        setVideos(r.data || []);
      } catch {
        setVideos([]);
      }
    })();
  }, []);

  return (
    <>
      <PageHeroBanner
        src="/tapin-original-hero.png"
        alt="Tap IN ORIGINAL — Original Films · Bold Stories · Independent Voices."
        testid="originals-page-hero"
        hotspots={ORIGINALS_HOTSPOTS}
      />
      <div data-testid="originals-page" className="px-4 sm:px-8 md:px-12 pb-20 max-w-7xl mx-auto">
        <header className="mb-8">
          <div className="text-[10px] uppercase tracking-[0.3em] text-tv-accent font-bold">Tap IN Originals</div>
          <h1 className="font-display font-black text-4xl sm:text-5xl text-white tracking-tighter mt-2">Bold stories from independent voices</h1>
          <p className="text-white/60 mt-2 text-sm sm:text-base max-w-3xl">Films and series produced or championed by Tap IN — every minute, made by an independent creator.</p>
        </header>

        {videos.length === 0 ? (
          <div className="text-white/60 text-center py-24" data-testid="originals-empty">No originals released yet — check back soon.</div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {videos.map((v) => <VideoCard key={v.id} item={v} fullWidth />)}
          </div>
        )}
      </div>
    </>
  );
}
